module.exports = __webpack_public_path__ + "img/两面针.cdc8122.cdc81228.png";